export default __webpack_public_path__ + "static/media/phase3-bg.5863da8f.svg";